import { PartialTranslation } from '../translations';

export const th: PartialTranslation = {
  newChat: 'แชทใหม่',
  search: 'ค้นหา',
  user: 'ผู้ใช้',
  settings: 'การตั้งค่า',
  language: 'ภาษา',
  getHelp: 'ขอความช่วยเหลือ',
  viewAllPlans: 'ดูแผนทั้งหมด',
  learnMore: 'เรียนรู้เพิ่มเติม',
  logOut: 'ออกจากระบบ',
  chooseLanguage: 'เลือกภาษา',
  chooseYourPreferredLanguage: 'เลือกภาษาที่คุณต้องการ',
  searchLanguages: 'ค้นหาภาษา...',
  autoDetect: 'ตรวจหาอัตโนมัติ',
  noLanguagesFound: 'ไม่พบภาษา',
  askAnything: 'ถามอะไรก็ได้',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'ส่วนตัว',
  freePlan: 'แผนฟรี',
  current: 'ปัจจุบัน',
  close: 'ปิด',
  archive: 'เก็บถาวร',
  delete: 'ลบ',
  confirmDelete: 'คุณแน่ใจหรือไม่ว่าต้องการลบแชทนี้?',
  confirmArchive: 'คุณแน่ใจหรือไม่ว่าต้องการเก็บแชทนี้ไว้ในที่เก็บถาวร?',
  deleteCannotUndo: 'การกระทำนี้ไม่สามารถยกเลิกได้',
  archiveCanFind: 'คุณสามารถหาได้ในรายการที่เก็บถาวรหลังจากการเก็บถาวร',
  
  // 资源面板
  resources: 'ทรัพยากร',
  addResource: 'เพิ่มทรัพยากร',
  deleteResource: 'ลบทรัพยากร',
  noMatchingResourcesFound: 'ไม่พบทรัพยากรที่ตรงกัน',
  noResourcesAvailable: 'ไม่มีทรัพยากรที่ใช้ได้',
  hideResources: 'ซ่อนทรัพยากร',
  showResources: 'แสดงทรัพยากร',
  
  // 聊天输入框
  typeMessage: 'พิมพ์ข้อความ...',
  thinkingOptions: 'ตัวเลือกการคิด',
  deleteFile: 'ลบไฟล์',
  clearSelection: 'ล้างการเลือก',
  addAttachment: 'เพิ่มไฟล์แนบ',
  sendMessage: 'ส่งข้อความ',
  
  // 思考模式选项
  deepInsight: 'ความเข้าใจลึก · การวิเคราะห์ผิวเผิน',
  deepInsightDesc: 'ความเข้าใจอย่างรวดเร็วของจุดสำคัญ',
  deepExploration: 'การสำรวจลึก · การวิเคราะห์ครอบคลุม',
  deepExplorationDesc: 'การวิจัยเชิงลึกหลายมิติ',
  deepDeconstruction: 'การถอดรหัสลึก · การโต้แย้งเป็นระบบ',
  deepDeconstructionDesc: 'การวิเคราะห์ทีละชั้นอย่างต่อเนื่อง',
  
  // 写作模式选项
  contractReview: 'การตรวจสอบสัญญา · การระบุความเสี่ยง',
  contractReviewDesc: 'การวิเคราะห์ข้อกำหนดและการตรวจสอบการปฏิบัติตาม',
  textPolish: 'การปรับปรุงข้อความ · การแสดงออกอย่างมืออาชีพ',
  textPolishDesc: 'การปรับปรุงภาษาและการปรับโครงสร้าง',
  legalDocuments: 'เอกสารทางกฎหมาย · การร่างมาตรฐาน',
  legalDocumentsDesc: 'การเขียนเอกสารทางกฎหมายอย่างมืออาชีพ',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'เข้าสู่ระบบ',
  register: 'ลงทะเบียน',
  welcomeBack: 'ยินดีต้อนรับสู่ LawHelper',
  loginSubtitle: 'ผู้ช่วยวิจัยกฎหมาย AI ของคุณ',
  continueWithGoogle: 'ดำเนินการต่อด้วย Google',
  continueWithMicrosoft: 'ดำเนินการต่อด้วย Microsoft',
  continueWithWeChat: 'ดำเนินการต่อด้วย WeChat',
  orContinueWith: 'หรือดำเนินการต่อด้วย',
  emailTab: 'อีเมล',
  phoneTab: 'โทรศัพท์',
  emailPlaceholder: 'กรอกอีเมลของคุณ',
  phonePlaceholder: 'กรอกหมายเลขโทรศัพท์',
  codePlaceholder: 'กรอกรหัส 6 หลัก',
  sending: 'กำลังส่ง...',
  verifying: 'กำลังตรวจสอบ...',
  verify: 'ยืนยัน',
  sendMagicLink: 'ส่งลิงก์มหัศจรรย์',
  getVerificationCode: 'รับรหัส',
  resendCode: 'ส่งรหัสอีกครั้ง',
  resendIn: 'ส่งอีกครั้งใน',
  magicLinkSent: 'ลิงก์มหัศจรรย์ถูกส่งไปยังอีเมลของคุณแล้ว',
  magicLinkHint: 'เราจะส่งลิงก์ที่ปลอดภัยไปยังอีเมลของคุณ',
  otpSent: 'รหัสยืนยันถูกส่งแล้ว',
  agreeToTerms: 'ด้วยการดำเนินการต่อ คุณยอมรับ',
  privacyPolicy: 'นโยบายความเป็นส่วนตัว',
  termsOfService: 'ข้อกำหนดในการให้บริการ',
  and: 'และ',
  privacyTitle: 'ความเป็นส่วนตัวของคุณสำคัญ',
  privacyIntro: 'เราใช้คุกกี้และเทคโนโลยีที่คล้ายกันเพื่อมอบประสบการณ์ที่ดีที่สุดให้กับคุณ',
  essentialCookies: 'คุกกี้ที่จำเป็น',
  essentialDesc: 'จำเป็นสำหรับการทำงานของเว็บไซต์',
  analyticsCookies: 'คุกกี้วิเคราะห์',
  analyticsDesc: 'ช่วยเราปรับปรุงบริการ',
  marketingCookies: 'คุกกี้การตลาด',
  marketingDesc: 'ใช้สำหรับเนื้อหาส่วนบุคคล',
  acceptAll: 'ยอมรับทั้งหมด',
  essentialOnly: 'เฉพาะที่จำเป็น',
  customize: 'ปรับแต่ง',
  savePreferences: 'บันทึกการตั้งค่า',
  back: 'กลับ',
  readPrivacyPolicy: 'อ่านนโยบายความเป็นส่วนตัวของเรา',
  cookiePolicy: 'นโยบายคุกกี้',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'ตรวจสอบ AI',
  aiDraft: 'ร่าง AI',
  smartAssistant: 'เทมเพลต',

  // 知识库搜索
  enableKnowledgeSearch: 'เปิดใช้งานการค้นหา',
  knowledgeSearchDesc: 'AI ค้นหาจากเอกสารของคุณ',
  clickToDisable: 'ปิดใช้งาน',
  clickToEnable: 'เปิดใช้งาน',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'ปิดแผงทรัพยากร',
  uploading: 'กำลังอัปโหลด %{fileName}...',
  processing: 'กำลังประมวลผล %{fileName}...',
  uploadSuccess: '✓ อัปโหลด %{fileName} สำเร็จ',
  uploadError: '✗ อัปโหลดล้มเหลว: %{error}',
  quickAnswer: 'คำตอบด่วน',
  quickAnswerDesc: 'ตอบคำถามง่ายๆ อย่างรวดเร็ว',
  cancelRequest: 'ยกเลิก',
  library: 'ไลบรารี',
  filterAll: 'ทั้งหมด',
  filterChat: 'แชท',
  filterReview: 'ตรวจสอบ',
  filterDraft: 'ร่าง',
  filterTemplate: 'แม่แบบ',
  filterForm: 'แบบฟอร์ม',
  thinking: 'กำลังคิด...',
  thinkingProcess: 'กระบวนการคิด',
  analyzingLegalLogic: 'วิเคราะห์ตรรกะทางกฎหมาย...',
  lawhelperThinking: 'Lawhelper กำลังคิด...',
  serviceError: 'ข้อผิดพลาดของบริการ',
  uploaded: 'อัปโหลดแล้ว',
  settingsGeneral: 'ทั่วไป',
  settingsNotifications: 'การแจ้งเตือน',
  settingsAppearance: 'ลักษณะ',
  settingsProfile: 'โปรไฟล์',
  settingsResponseNotifications: 'การแจ้งเตือนการตอบกลับ',
  settingsResponseNotificationsDesc: 'แจ้งเตือนเมื่อ AI ตอบกลับเสร็จ',
  settingsColorMode: 'โหมดสี',
  settingsLight: 'สว่าง',
  settingsDark: 'มืด',
  settingsSystem: 'ระบบ',
  about: 'เกี่ยวกับ',
  reviewTitle: 'ตรวจสอบเอกสาร',
  exitReview: 'ออกจากการตรวจสอบ',
  uploadPrompt: 'อัปโหลด PDF เพื่อตรวจสอบ',
  uploadButton: 'เลือกไฟล์',
  startChatConfig: 'พิมพ์ "ตรวจสอบเอกสารนี้"',
  reviewPlaceholder: 'พิมพ์ข้อความ...',
  analyzing: 'กำลังตรวจสอบ...',
  reviewComplete: 'ตรวจสอบเสร็จสิ้น',
  issuesFound: 'พบ %{count} ปัญหา',
  draftTitle: 'ร่างเอกสารทางกฎหมาย',
  draftPlaceholder: 'แก้ไขที่นี่หรือขอให้ AI...',
  analyzingTemplate: 'วิเคราะห์แม่แบบ %{name}...',
  templateAnalyzed: '✅ วิเคราะห์แม่แบบ %{name} เสร็จแล้ว!',
  templateAnalysisPrompt: 'วิเคราะห์ข้อกำหนดหลัก',
  parsingFailed: '⚠️ ไม่สามารถวิเคราะห์ไฟล์ได้',
  generating: 'กำลังสร้าง...',
  generatedSuccess: '✅ สร้างเอกสารแล้ว!',
  drafterWelcome: 'ยินดีต้อนรับสู่ผู้ช่วยเอกสาร AI',
  drafterYouCan: 'คุณสามารถ:',
  drafterUploadTemplate: 'อัปโหลดแม่แบบเพื่อวิเคราะห์',
  drafterDescribeNeeds: 'อธิบายความต้องการเอกสาร',
  drafterLetAiHelp: 'AI ช่วยร่างสัญญา ข้อตกลง ฯลฯ',
  drafterExamples: 'ตัวอย่าง:',
  drafterExampleRental: '"ร่างสัญญาเช่า"',
  drafterExampleLabor: '"กรอกสัญญาจ้างงาน"',
  drafterInputPlaceholder: 'อธิบายความต้องการของคุณ...',
  drafterThinking: 'กำลังคิด...',
  drafterHistoryTitle: 'ประวัติ',
  drafterNoHistory: 'ไม่มีประวัติ',
  drafterNewChat: 'แชทใหม่',
  drafterHistory: 'ประวัติ',
  drafterRemoveAttachment: 'ลบไฟล์แนบ',
  drafterLineHeight: 'ความสูงบรรทัด',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'ส่งออกเป็น Word (.docx)',
  drafterExportPdf: 'ส่งออกเป็น PDF',
  drafterSave: 'บันทึกเอกสาร',
  drafterDownload: 'ดาวน์โหลดเอกสาร',
  drafterUndo: 'เลิกทำ',
  drafterRedo: 'ทำซ้ำ',
  drafterBold: 'ตัวหนา',
  drafterItalic: 'ตัวเอียง',
  drafterStrike: 'ขีดทับ',
  drafterUnderline: 'ขีดเส้นใต้',
  drafterHighlight: 'ไฮไลท์',
  drafterLink: 'แทรกลิงก์',
  drafterAlignLeft: 'ชิดซ้าย',
  drafterAlignCenter: 'กึ่งกลาง',
  drafterAlignRight: 'ชิดขวา',
  drafterAlignJustify: 'เต็มบรรทัด',
  drafterList: 'รายการ',
  drafterBulletList: 'รายการสัญลักษณ์',
  drafterOrderedList: 'รายการลำดับ',
  drafterTaskList: 'รายการงาน',
  drafterOpenResource: 'เปิดแผงทรัพยากร',
  drafterStopGeneration: 'หยุดการสร้าง',
  drafterAgentMode: 'โหมด Agent เปิดอยู่',
  drafterAgentModeOn: 'โหมด Agent เปิดอยู่',
  drafterAgentModeOff: 'โหมดปกติ',
  drafterUploadAttachment: 'อัปโหลดไฟล์แนบ',
  drafterExit: 'ออก',
  drafterConfirm: 'ยืนยัน',
  drafterOpenLink: 'เปิดลิงก์',
  drafterDeleteLink: 'ลบลิงก์',
  drafterQuote: 'อ้างอิง',
  workflowTitle: 'เวิร์กโฟลว์ AI',
  workflowRunning: 'กำลังทำงาน...',
  workflowReady: 'พร้อม',
  workflowCompleted: 'เสร็จสิ้น',
  workflowStartFailed: 'เริ่มเวิร์กโฟลว์ล้มเหลว',
  workflowExecutionFailed: 'การทำงานล้มเหลว',
  workflowInterrupted: 'เวิร์กโฟลว์ถูกขัดจังหวะ',
  workflowProcessing: 'กำลังประมวลผล...',
  workflowStepsCompleted: 'ขั้นตอนเสร็จสิ้น',
  workflowStepsTotal: 'เวิร์กโฟลว์เสร็จสิ้น (%{count} ขั้นตอน)',
  acceptChanges: 'ยอมรับการเปลี่ยนแปลง',
  rejectChanges: 'ปฏิเสธการเปลี่ยนแปลง',
  changesAccepted: 'ยอมรับแล้ว',
  changesRejected: 'ปฏิเสธแล้ว',
  stopWorkflow: 'หยุด',
  restartWorkflow: 'เริ่มใหม่',
  startDrafting: 'เริ่มร่าง',
  interrupt: 'หยุด',
  documentSubject: 'หัวเรื่องเอกสาร *',
  documentType: 'ประเภทเอกสาร',
  jurisdiction: 'เขตอำนาจศาล',
  specialRequirements: 'ข้อกำหนดพิเศษ (ไม่บังคับ)',
  clickStartDrafting: 'คลิก "เริ่มร่าง"',
  docTypeContract: 'สัญญา',
  docTypeAgreement: 'ข้อตกลง',
  docTypeNotice: 'ประกาศ',
  docTypeLetter: 'จดหมาย',
  docTypePetition: 'คำร้อง',
  docTypeWill: 'พินัยกรรม',
  docTypePowerOfAttorney: 'หนังสือมอบอำนาจ',
  countryChina: 'จีน',
  countryUSA: 'สหรัฐอเมริกา',
  countryGermany: 'เยอรมนี',
  countryJapan: 'ญี่ปุ่น',
  countryFrance: 'ฝรั่งเศส',
  countryUK: 'สหราชอาณาจักร',
  citationVerified: 'ยืนยันแล้ว',
  citationUnverified: 'ยังไม่ยืนยัน',
  imageLoadFailed: 'โหลดภาพล้มเหลว',
  smartDocTitle: 'ผู้ช่วยเอกสารอัจฉริยะ',
  smartDocChatTitle: 'ผู้ช่วยเอกสาร AI',
  smartDocDropPrompt: 'วางไฟล์ PDF ที่นี่',
  smartDocSelectFile: 'เลือกไฟล์',
  smartDocOr: 'หรือ',
  smartDocWelcomeTitle: 'ยินดีต้อนรับสู่ผู้ช่วย AI',
  smartDocWelcomeYouCan: 'คุณสามารถ:',
  smartDocUploadForAI: 'อัปโหลดแม่แบบ',
  smartDocDescribeDoc: 'อธิบายความต้องการ',
  smartDocLetAIDraft: 'AI ช่วยร่างสัญญา',
  smartDocExamples: 'ตัวอย่าง:',
  smartDocExampleRental: '"ร่างสัญญาเช่า"',
  smartDocExampleLabor: '"กรอกสัญญาจ้างงาน"',
  smartDocInputPlaceholder: 'อธิบายความต้องการ...',
  smartDocRemoveAttachment: 'ลบไฟล์แนบ',
  smartDocOpenResources: 'เปิดทรัพยากร',
  smartDocExit: 'ออก',
  reviewStartFailed: 'เริ่มการตรวจสอบล้มเหลว',
  reviewFailed: 'การตรวจสอบล้มเหลว',
  reviewFoundIssues: 'ตรวจสอบเสร็จ พบ %{count} ปัญหา',
  cannotReadStream: 'ไม่สามารถอ่านสตรีมได้',
  parseEventFailed: 'วิเคราะห์เหตุการณ์ล้มเหลว',
  errorPrefix: 'ข้อผิดพลาด',
  unknownError: 'ข้อผิดพลาดที่ไม่ทราบ',
  file: 'ไฟล์',
  loading: 'กำลังโหลด...',
  localFolders: 'โฟลเดอร์ในเครื่อง',
  selectLocalFolder: 'เลือกโฟลเดอร์ในเครื่อง',
  reselectFolder: 'เปลี่ยนโฟลเดอร์',
  addToContext: 'เพิ่มในแชท',
  saveFile: 'บันทึก',
  renameFile: 'เปลี่ยนชื่อ',
  fileSaved: 'บันทึกไฟล์แล้ว',
  fileRenamed: 'เปลี่ยนชื่อไฟล์เป็น %{name}',
  browserNotSupported: 'เบราว์เซอร์ไม่รองรับการเข้าถึงโฟลเดอร์',
  noFolderSelected: 'เลือกโฟลเดอร์เพื่อเรียกดูไฟล์',
  scanningFolder: 'กำลังสแกนโฟลเดอร์...',
  selectFileToPreview: 'เลือกไฟล์เพื่อดูตัวอย่าง',
  aiAnalyze: 'วิเคราะห์ AI',
};
